'use strict';

/** Parameters:
*
*  -- [-<namespace>] is an optional namespace to be used across attributes
*
*  data-sw-char-count="<max count>"
*
*    The max chars we should be counting to. 
*    If no value is provided it will check the maxlength property
*
*  data-sw-char-count-countdown-selector="<css selector>"
*
*    The selector for the elements to hold the count
*
*
*  data-sw-char-count-at-<count>[-<namespace>]="<class(es)>"
*
*    The class(es) to be added after count value
*
*
*  data-sw-char-count-at-<count>[-<namespace>]-before="<class(es)>"
*
*    The class(es) to be added before count value
*
*
*  data-sw-char-count-at-<count>[-<namespace>]-selector="<selector(s)>"
*
*    Selectors to use for this count
 *
*/
var _  = require('underscore');
var $ = require('js/sw-jquery/sw-jquery');

var ERROR_CLASS = 'sw--text-alert';
var ROOT_NAME = 'swCharCount';
var CHAR_COUNT_AT_ATTR = ROOT_NAME + 'At';
var COUNTDOWN_SELECTOR_NAME = ROOT_NAME + 'CountdownSelector';
var THROTTLE_MS = 100;
var DEFAULT_NAMESPACE = '_namespace';
var TYPE_EL = 'element';
var TYPE_AFTER_CLASS = 'after';
var TYPE_BEFORE_CLASS ='before';
var TYPE_SELECTOR = 'selector';

var camelCaseRegex = /([A-Z]?[^A-Z]*)/g;
var newlineRegex = /(\r\n|\n|\r)/g;
var atKeywords = [TYPE_SELECTOR, TYPE_BEFORE_CLASS];

/**
 * Adjusts for carriage returns to play nice with maxlength
 * http://stackoverflow.com/questions/10030921/chrome-counts-characters-wrong-in-textarea-with-maxlength-attribute
 * @param str
 * @returns {*}
 */
function stringLengthCounter(str) {
  var newLines = str.match(newlineRegex);
  var addition = _.isNull(newLines) ? 0 : newLines.length;
  return str.length + addition;
}

/**
 *
 * @param map
 * @param count
 * @param namespace
 * @param valType
 * @param val
 * @returns {*}
 */
function makeAtMap(map, count, namespace, valType, val) {
  map[count] = map[count] ? map[count] : {};
  map[count][namespace] = map[count][namespace] ? map[count][namespace] : {};
  map[count][namespace][valType] = val;
  return map;
}

/**
 * Updates all info for sw-char-count
 * @param $input
 */
function updateCharCount($input) {
  var data = $input.swDataParams(ROOT_NAME);
  var atCounts = $input.swDataParams(CHAR_COUNT_AT_ATTR);
  var maxCount = data[ROOT_NAME];
  maxCount = _.isUndefined(maxCount) || maxCount === '' ? $input.attr('maxlength') : maxCount;
  var $countdowns = data[COUNTDOWN_SELECTOR_NAME] ? $(data[COUNTDOWN_SELECTOR_NAME]) : undefined;
  var text = $input.val();
  var totalChars = stringLengthCounter(text);
  var charsLeft = maxCount - totalChars;

  var countClassMap = {};
  countClassMap = makeAtMap(countClassMap, maxCount, DEFAULT_NAMESPACE, TYPE_AFTER_CLASS, ERROR_CLASS);
  countClassMap = makeAtMap(countClassMap, maxCount, DEFAULT_NAMESPACE, TYPE_EL, $countdowns);
  countClassMap = _.reduce(atCounts, function (countClassMap, attrVal, attrName) {
    var atInfo = attrName.replace(CHAR_COUNT_AT_ATTR, '').replace('-', '');
    var typeIndex = 2;
    var info, count, namespace, valType;
    if(!_.isEmpty(atInfo)) {
      info = atInfo.match(camelCaseRegex);
      if(info.length > 0) {
        info = _.map(info, function (str) {
          return str.toLowerCase();
        });
        count = parseInt(info[0], 10);
        namespace = info[1];
        if(_.isEmpty(namespace) || (atKeywords.indexOf(namespace) > -1)) {
          namespace = DEFAULT_NAMESPACE;
          typeIndex = 1;
        }

        valType = _.isEmpty(info[typeIndex]) ? TYPE_AFTER_CLASS : info[typeIndex];
        if(valType === TYPE_SELECTOR) {
          valType = TYPE_EL;
          attrVal = $(attrVal);
        }

        countClassMap = makeAtMap(countClassMap, count, namespace, valType, attrVal);
      }
    }
    return countClassMap;
  }, countClassMap);



  if($countdowns) {
    $countdowns.text(charsLeft);
    _.each(countClassMap, function (countInfo, atCount) {
      _.each(countInfo, function (info) {
        var $el = info[TYPE_EL] ? info[TYPE_EL] : $countdowns;
        var afterClass = info[TYPE_AFTER_CLASS] ? info[TYPE_AFTER_CLASS] : '';
        var beforeClass = info[TYPE_BEFORE_CLASS] ? info[TYPE_BEFORE_CLASS] : '';
        if(totalChars >= atCount) {
          $el.addClass(afterClass).removeClass(beforeClass);
        } else {
          $el.removeClass(afterClass).addClass(beforeClass);
        }
      });
    });

  }
}

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-char-count]').each(function() {
    var $el = $(this);

    updateCharCount($el);

    $el.on('keyup', _.throttle(function () {
      updateCharCount($el);
    }, THROTTLE_MS));

  });

};
